// 用网关实现的登录与后台访问---------------------------------------开始
// 网关地址
// 正式
export const JPT_URL = 'http://jpt2ht.faujor.com:7070'
// 测试
// export const JPT_URL = 'http://8.130.52.12:30071'
// 开发
// export const JPT_URL = 'http://localhost:8040'

// 模块配置
// 基础模块
export const BASIC = '/basic'
// 登录于获取用户信息
export const LOGIN = '/token/generateToken'
export const USERINFO = BASIC + '/user/front/info'
// 用网关实现的登录与后台访问---------------------------------------结束
/** ***************************费用报销模块**********************************/
export const DORM = '/reimburse-service'
export const DORM_URL = DORM
// *******项目模块********
export const PROJECT = '/project-service'
// *******流程模块********
export const EXT = '/ext-service'
// 合同URL
export const CONT_URL = PROJECT + '/cm'
// 合同付款
export const CM_PAY_URL = PROJECT + '/cmPay'

/** ****************************合同开票模块start*************************************/
// 合同开票
export const INVO_URL = PROJECT + '/cmInvo'
/** ****************************合同开票模块end*************************************/
// 项目立项
export const PROJ_URL = PROJECT + '/pm'
// 项目预算
export const BUDGET_URL = PROJECT + '/budget'
// flyback申请
export const FLYBACK_URL = PROJECT + '/flyback'
// 流程管理
export const FLOW_URL = EXT + '/flow'
export const EXT_URL = EXT + '/ext'
export const HIELES_URL = EXT + '/hiEles'

// 字典表
export const DIC_URL = BASIC + '/dic'
// 内部人员
export const INNER_USER = BASIC + '/innerUser'
// 省市区配置
export const PROV_CITY_URL = BASIC + '/provCity'



// WEBPACK FOOTER //
// ./src/config/constant.js